(() => {
  'use strict';
  const fieldId = 'custom#product';
  const handleId = 'custom#product_handle';
  const styleId = 'sv-oddit-warranty-form-style';
  const css = `
    section[role='dialog']{max-width:none!important;width:100%!important;background:transparent!important;padding:0!important}
    section{overflow:visible!important}
    section[role='dialog']>div:empty{display:none!important}
    section[role='dialog']>div:last-child{max-width:none!important;width:100%!important;padding:0!important}
    h2{font-size:26px!important;line-height:1.25!important;font-weight:700!important;letter-spacing:-.02em!important;margin:0!important;color:#272332!important}
    section[role='dialog'] p{font-size:14px!important;line-height:1.6!important;color:#625d6d!important}
    form[data-testid='form']{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:16px!important;margin-top:24px!important}
    form[data-testid='form']>div{min-width:0}
    form[data-testid='form']>div:has([id='first_name']){grid-column:1;grid-row:1}
    form[data-testid='form']>div:has([id='last_name']){grid-column:2;grid-row:1}
    form[data-testid='form']>div:has([id='email']){grid-column:1;grid-row:2}
    form[data-testid='form']>div:has([id='custom#order_number']){grid-column:2;grid-row:2}
    form[data-testid='form']>div:has(button[aria-labelledby*='where_did_you_purchase']){grid-column:1/-1;grid-row:3}
    form[data-testid='form']>div:has([id='custom#product']){grid-column:1/-1;grid-row:4}
    form[data-testid='form']>div:has([id='custom#product_handle']){display:none!important}
    form[data-testid='form']>button[type='submit']{grid-column:1/-1;display:flex!important;align-items:center!important;justify-content:center!important;text-align:center!important;box-sizing:border-box!important;min-height:52px!important;padding:14px 18px!important;line-height:1.4!important;border-radius:999px!important;font-weight:700!important;background:#7563a8!important;color:#fff!important}
    section[role='dialog'] [class*='_formDisclaimer_'] p{font-size:11px!important;line-height:1.5!important;margin:12px 0 0!important}
    [class*='_formDisclaimer_'] a{color:#62518f!important;text-underline-offset:2px}
    input[type='text'],button[aria-labelledby*='selector-label']{box-sizing:border-box!important;min-height:56px!important;height:56px!important;border-radius:10px!important;font-size:15px!important;background:#fff!important}
    input[type='text']{padding:22px 14px 8px!important}
    [class*='_dropdownContainer_']{top:calc(100% + 6px)!important;bottom:auto!important;transform:none!important;z-index:10!important;border:1px solid #d8d2e3!important;border-radius:10px!important;box-shadow:0 8px 24px #30224818!important;max-height:210px!important}
    [class*='_optionList_']{max-height:210px!important}
    input[type='text']+label{font-size:14px!important}
    .sv-oddit-product-field>input,.sv-oddit-product-field>label:not(.sv-oddit-product-label){display:none!important}
    .sv-oddit-product-label{display:block!important;font-size:14px!important;font-weight:650!important;margin:0 0 8px!important;color:#272332!important}
    .sv-oddit-product-field{position:relative}
    .sv-oddit-product-select{display:none!important}
    .sv-oddit-product-toggle{display:flex;align-items:center;justify-content:space-between;gap:12px;box-sizing:border-box;width:100%;min-height:56px;border:1px solid #d8d2e3;border-radius:10px;padding:14px;background:#fff;color:#272332;font:inherit;font-size:15px;line-height:1.4;text-align:left;cursor:pointer}
    .sv-oddit-product-toggle::after{content:'⌄';font-size:18px;flex-shrink:0}
    .sv-oddit-product-menu{position:absolute;top:calc(100% + 6px);left:0;right:0;max-height:230px;overflow-y:auto;overscroll-behavior:contain;padding:6px;background:#fff;border:1px solid #d8d2e3;border-radius:10px;box-shadow:0 8px 24px #30224818;z-index:11}
    .sv-oddit-product-menu[hidden]{display:none}
    .sv-oddit-product-menu button{display:block;box-sizing:border-box;width:100%;border:0;border-radius:6px;padding:11px 10px;background:#fff;text-align:left;color:#272332;font:inherit;font-size:14px;line-height:1.4;cursor:pointer}
    .sv-oddit-product-menu button[aria-selected='true'],.sv-oddit-product-menu button:hover{background:#eee7f8;color:#534576}
    .sv-oddit-product-toggle:focus-visible,.sv-oddit-product-menu button:focus-visible{outline:2px solid #7563a8;outline-offset:2px}
    [role='alert']{grid-column:1/-1}
    @media(max-width:540px){form[data-testid='form']{grid-template-columns:minmax(0,1fr)!important}form[data-testid='form']>div,form[data-testid='form']>button[type='submit']{grid-column:1!important;grid-row:auto!important}h2{font-size:24px!important}}
  `;
  function setNativeValue(input, value) {
    if (!input || input.value === value) return;
    const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }
  function setupDisclosure(container) {
    const card = container.querySelector('[data-sv-oddit-registration-card]');
    const panel = container.querySelector('[data-sv-oddit-registration-panel]');
    const button = container.querySelector('[data-sv-oddit-register-toggle]');
    const intro = container.querySelector('[data-sv-oddit-registration-intro]');
    const back = container.querySelector('[data-sv-oddit-registration-back]');
    if (!card || !panel || !button || !intro || !back) return;
    card.classList.add('is-enhanced'); panel.inert = true; panel.setAttribute('aria-hidden', 'true');
    button.hidden = false; back.hidden = false; button.setAttribute('aria-expanded', 'false');
    const focusForm = () => {
      if (card.classList.contains('is-open') && (document.activeElement === button || document.activeElement === document.body)) container.querySelector('shopify-forms-embed')?.shadowRoot?.getElementById('first_name')?.focus({ preventScroll: true });
    };
    panel.addEventListener('transitionend', e => { if (e.target === panel && e.propertyName === 'opacity') focusForm(); });
    const open = () => {
      card.classList.add('is-open'); panel.inert = false; panel.setAttribute('aria-hidden', 'false');
      intro.inert = true; intro.setAttribute('aria-hidden', 'true');
      button.setAttribute('aria-expanded', 'true');
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) focusForm();
    };
    button.addEventListener('click', open);
    back.addEventListener('click', () => {
      card.classList.remove('is-open'); panel.inert = true; panel.setAttribute('aria-hidden', 'true');
      intro.inert = false; intro.setAttribute('aria-hidden', 'false');
      button.setAttribute('aria-expanded', 'false');
      const restoreFocus = () => { if (!card.classList.contains('is-open')) button.focus({preventScroll:true}); };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) restoreFocus(); else setTimeout(restoreFocus, 480);
    });
    container.querySelectorAll('.sv-oddit-starter-links a').forEach(link => link.addEventListener('click', e => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      history.replaceState(null,'',link.hash);
    }));
  }
  function setupProductMenu(wrapper, select, label, cleanups) {
    const button = document.createElement('button'); button.type = 'button'; button.className = 'sv-oddit-product-toggle'; button.id = select.id + '-toggle'; label.htmlFor = button.id;
    const list = document.createElement('div'); list.className = 'sv-oddit-product-menu'; list.id = select.id + '-options'; list.role = 'listbox'; list.hidden = true;
    label.id = select.id + '-label'; button.role = 'combobox'; button.setAttribute('aria-labelledby', label.id);
    button.setAttribute('aria-controls', list.id); button.setAttribute('aria-haspopup', 'listbox'); button.setAttribute('aria-expanded', 'false');
    list.setAttribute('aria-labelledby', label.id);
    const close = (focus) => { list.hidden = true; button.setAttribute('aria-expanded', 'false'); if (focus) button.focus(); };
    const options = [...select.options].filter(o => o.value).map(o => {
      const item = document.createElement('button'); item.type = 'button'; item.role = 'option'; item.textContent = o.text; item.dataset.value = o.value;
      item.addEventListener('click', () => { select.value = o.value; select.dispatchEvent(new Event('change', { bubbles: true })); refresh(); close(true); });
      list.appendChild(item); return item;
    });
    const refresh = () => {
      const title = select.selectedOptions[0]?.textContent || '—'; if (button.textContent !== title) button.textContent = title;
      options.forEach(o => o.setAttribute('aria-selected', String(o.dataset.value === select.value)));
    };
    const open = () => { list.hidden = false; button.setAttribute('aria-expanded', 'true'); (options.find(o=>o.dataset.value===select.value)||options[0])?.focus({preventScroll:true}); };
    button.addEventListener('click', () => list.hidden ? open() : close(false));
    button.addEventListener('keydown', e => { if (['ArrowDown','ArrowUp'].includes(e.key)) { e.preventDefault(); open(); } });
    list.addEventListener('keydown', e => {
      const index = options.indexOf(list.getRootNode().activeElement);
      if (e.key === 'Escape') { e.preventDefault(); close(true); }
      else if (e.key === 'Tab') close(false);
      else if (['ArrowDown','ArrowUp','Home','End'].includes(e.key)) {
        e.preventDefault(); const next = e.key==='Home'?0:e.key==='End'?options.length-1:(index+(e.key==='ArrowDown'?1:-1)+options.length)%options.length; options[next]?.focus();
      }
    });
    // Listen on the document: shadow-root listeners miss clicks above or outside the form.
    const outside = e => { if (!e.composedPath().includes(wrapper)) close(false); };
    document.addEventListener('pointerdown', outside, true);
    cleanups.push(() => document.removeEventListener('pointerdown', outside, true));
    wrapper.addEventListener('focusout', () => setTimeout(() => { if (!wrapper.contains(wrapper.getRootNode().activeElement)) close(false); }, 0));
    select.addEventListener('change', refresh); wrapper.append(button, list); refresh();
  }
  function enhance(container) {
    if (container.dataset.svOdditReady) return;
    container.dataset.svOdditReady = 'true';
    setupDisclosure(container);
    let choices;
    try { choices = JSON.parse(container.querySelector('[data-sv-oddit-product-options]').textContent); }
    catch (_) { return; }
    const productOrder = ['vortex-carpet-cleaner', 'solara-wake-up-light', 'swiftvein-shine-ultrasonic-cleaner', 'swiftvein-rise-digital-alarm-clock', 'stitch-sewing-machine', 'nimbus-white-noise-machine', 'astronaut-galaxy-projector'];
    const productRank = new Map(productOrder.map((handle, index) => [handle, index]));
    choices.sort((a, b) => (productRank.get(a.handle) ?? productOrder.length) - (productRank.get(b.handle) ?? productOrder.length));
    let selected = choices.find(p => p.handle === container.dataset.defaultProduct)?.handle || '';
    const seen = new WeakSet();
    const observers = [];
    const cleanups = [];
    const setup = (host) => {
      const root = host.shadowRoot;
      if (!root) return;
      if (!root.getElementById(styleId)) {
        const style = document.createElement('style'); style.id = styleId; style.textContent = css; root.appendChild(style);
      }
      const disclaimer = root.querySelector('[class*="_formDisclaimer_"] p');
      if (disclaimer && !disclaimer.querySelector('a') && container.dataset.privacyUrl) {
        const text = disclaimer.textContent;
        const privacy = container.dataset.privacyLabel;
        const match = text.match(/[^.!?]*(?:privacy|datenschutz)[^.!?]*[.!?]?\s*$/i);
        const index = text.toLocaleLowerCase().indexOf(privacy.toLocaleLowerCase().replace(/\.$/, '')) >= 0
          ? text.toLocaleLowerCase().indexOf(privacy.toLocaleLowerCase().replace(/\.$/, ''))
          : match ? match.index + match[0].length - match[0].trimStart().length : -1;
        if (index >= 0) {
          const link = document.createElement('a'); link.href = container.dataset.privacyUrl;
          link.textContent = text.slice(index);
          disclaimer.replaceChildren(document.createTextNode(text.slice(0,index)), link);
        }
      }
      const input = root.getElementById(fieldId);
      const handle = root.getElementById(handleId);
      if (!input || !handle) return;
      const wrapper = input.parentElement;
      wrapper.classList.add('sv-oddit-product-field');
      let select = wrapper.querySelector('.sv-oddit-product-select');
      if (!select) {
        const label = document.createElement('label'); label.className = 'sv-oddit-product-label';
        label.textContent = root.querySelector(`label[for='${fieldId}']`)?.textContent || 'Product';
        select = document.createElement('select'); select.className = 'sv-oddit-product-select'; select.id = 'sv-oddit-warranty-product'; select.required = true;
        label.htmlFor = select.id;
        const empty = new Option('—', ''); select.add(empty);
        choices.forEach(p => select.add(new Option(p.title, p.handle)));
        select.value = selected;
        select.addEventListener('change', () => {
          selected = select.value;
          const product = choices.find(p => p.handle === selected);
          setNativeValue(root.getElementById(fieldId), product?.title || '');
          setNativeValue(root.getElementById(handleId), product?.handle || '');
        });
        wrapper.append(label, select);
        setupProductMenu(wrapper, select, label, cleanups);
      }
      const product = choices.find(p => p.handle === selected);
      setNativeValue(input, product?.title || ''); setNativeValue(handle, product?.handle || '');
    };
    const discover = () => container.querySelectorAll('shopify-forms-embed').forEach(host => {
      setup(host);
      if (host.shadowRoot && !seen.has(host)) {
        seen.add(host);
        const observer = new MutationObserver(() => setup(host));
        observer.observe(host.shadowRoot, { childList: true, subtree: true }); observers.push(observer);
      }
    });
    const outer = new MutationObserver(discover);
    outer.observe(container, { childList: true, subtree: true }); observers.push(outer);
    discover();
    // The native form attaches its shadow root asynchronously, without a light-DOM mutation.
    let attempts = 0;
    const timer = setInterval(() => { discover(); if (++attempts >= 40 || container.querySelector('shopify-forms-embed')?.shadowRoot?.getElementById(fieldId)) clearInterval(timer); }, 250);
    document.addEventListener('shopify:section:unload', e => {
      if (e.target.contains(container)) { observers.forEach(o => o.disconnect()); cleanups.forEach(fn=>fn()); clearInterval(timer); }
    });
  }
  function setupSupport() {
    const source = document.querySelector('template[data-sv-oddit-support]');
    if (!source) return;
    const main = source.closest('.shopify-section')?.parentElement;
    if (!main) return;
    const find = key => document.getElementById(`shopify-section-${source.dataset.prefix}__${source.dataset[key]}`);
    const video = find('video'), update = find('update'), faq = find('faq'), downloads = find('downloads');
    if (!video || !faq || !downloads) return;
    let layout = main.querySelector('.sv-oddit-support-layout');
    if (!layout) {
      layout = document.createElement('div'); layout.className = 'sv-oddit-support-layout';
      const left = document.createElement('div'), right = document.createElement('div');
      left.className = 'sv-oddit-support-left'; right.className = 'sv-oddit-support-right';
      layout.append(left, right); video.before(layout);
    }
    const left = layout.querySelector('.sv-oddit-support-left'), right = layout.querySelector('.sv-oddit-support-right');
    [video, update].filter(Boolean).forEach(node => { if (node.parentElement !== left) left.append(node); });
    if (faq.parentElement !== right) right.prepend(faq);
    downloads.querySelector('.sv-oddit-support-manuals')?.remove();
    downloads.prepend(source.content.cloneNode(true));
    if (downloads.parentElement !== right) right.append(downloads);
    const updateCard = update?.querySelector('[class^="ai-software-update-container-"]');
    if (updateCard && !updateCard.querySelector('.sv-oddit-software-toggle')) {
      const heading = updateCard.querySelector('h2');
      const panel = document.createElement('div'); panel.className = 'sv-oddit-software-panel'; panel.id = `${update.id}-panel`;
      const button = document.createElement('button'); button.type = 'button'; button.className = 'sv-oddit-software-toggle';
      button.textContent = heading?.textContent || ''; button.setAttribute('aria-controls',panel.id); button.setAttribute('aria-expanded','false');
      [...updateCard.children].forEach(child => panel.append(child)); updateCard.append(button,panel);
      button.addEventListener('click',()=>button.setAttribute('aria-expanded',String(button.getAttribute('aria-expanded')!=='true')));
    }
    faq.querySelectorAll('.faq-question').forEach((question, index) => {
      const answer = question.nextElementSibling;
      if (!answer || question.dataset.svOdditSupport) return;
      question.dataset.svOdditSupport = 'true'; question.role = 'button'; question.tabIndex = 0;
      answer.id ||= `sv-oddit-support-answer-${index}`; question.setAttribute('aria-controls', answer.id);
      const sync = () => question.setAttribute('aria-expanded', String(question.parentElement.classList.contains('open')));
      question.addEventListener('click', () => queueMicrotask(sync));
      question.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); question.click(); } }); sync();
    });
    faq.querySelectorAll('.faq-tab').forEach(tab => {
      if (tab.dataset.svOdditSupport) return;
      tab.dataset.svOdditSupport = 'true'; tab.role = 'button'; tab.tabIndex = 0;
      tab.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tab.click(); } });
    });
  }
  const start = () => { document.querySelectorAll('[data-sv-oddit-starter]').forEach(enhance); setupSupport(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', e => {
    if (!e.target.querySelector('template[data-sv-oddit-support]')) return;
    const layout = document.querySelector('.sv-oddit-support-layout');
    if (layout) { layout.querySelector('.sv-oddit-support-manuals')?.remove(); layout.querySelectorAll('.shopify-section').forEach(node => layout.before(node)); layout.remove(); }
  });
})();
